module.exports = __webpack_public_path__ + "img/gx.f4ac9f07.png";